<template>
  <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 50 50" xml:space="preserve">
    <path :style="`fill: ${setFillColors.inner}`" d="M20.68 33.65a.71.71 0 0 1-.51-.21l-7.2-7.2a.736.736 0 0 1 0-1.03c.28-.28.74-.28 1.03 0l6.69 6.69 15.33-15.33c.28-.28.74-.28 1.03 0 .28.28.28.74 0 1.03L21.19 33.44c-.14.14-.33.21-.51.21z" style="fill:#e5231b"/>
    <path :style="`fill: ${setFillColors.outer}`" d="M25 49C11.77 49 1 38.23 1 25S11.77 1 25 1s24 10.77 24 24-10.77 24-24 24zm0-46.55C12.57 2.45 2.45 12.57 2.45 25c0 12.43 10.11 22.55 22.55 22.55 12.43 0 22.55-10.11 22.55-22.55C47.55 12.57 37.43 2.45 25 2.45z" style="fill:#065894"/>
  </svg>
</template>

<script>
export default {
  name: 'IconStep3',
  props: ['colorState'],
  computed: {
    setFillColors() {
      if (this.colorState === 'focus') {
        return {
          inner: '#E3342C',
          outer: '#045893',
        }
      } else if (this.colorState === 'complete') {
        return {
          inner: '#00BAF2',
          outer: '#00BAF2',
        }
      } else if (this.colorState === 'inactive') {
        return {
          inner: '#b3b3b3',
          outer: '#b3b3b3',
        }
      }
    }
  }
}
</script>
